import * as types from "@/store/constants/types";
export default {
  [types.UPDATE_APP_LAUNCH_TIME](state: any, payLoad: any) {
    state.appLaunchTime += 1;
  },
  [types.UPDATE_FIRST_USE_TIMESTAMP](state: any, payload: any) {
    if (!state.first_enter_timestamp) {
      state.first_enter_timestamp = new Date().getTime();
    }
  },
  [types.UPDATE_PRODUCT_DELIVED_DIALOG_APPEAR_TIME](state: any, payLoad: any) {
    state.delivedViewAppearTime += 1;
  },
  [types.UPDATE_PURCHASED_TIME](state: any, payLoad: any) {
    const payWay = payLoad;
    switch (payWay) {
      case "iap":
        state.purchasedTime.iap += 1;
        break;
      case "coin":
        state.purchasedTime.coin += 1;
        break;
      case "paypal":
        state.purchasedTime.paypal += 1;
        break;
      case "card":
        state.purchasedTime.card += 1;
        break;
      default:
        break;
    }
  },
  [types.ADD_PURCHASED_OFFER](state: any, payLoad: any) {
    state.purchasedOffer.push(payLoad);
  },
  [types.ADD_FAILED_OFFER](state: any, payLoad: any) {
    //先查找是否已经有了相同的订单，如果有则不做任何操作：
    const findOffer = state.failedOffer.find((offer: any) => {
      return offer.transaction_id === payLoad.transaction_id;
    });
    if (!findOffer) {
      state.failedOffer.unshift(payLoad);
    }
  },
  [types.DELETE_FAILED_OFFER](state: any, payLoad: any) {
    //先查找是否已经有了相同的订单，如果有则不做任何操作：
    const findIndex = state.failedOffer.findIndex((offer: any) => {
      return offer.transaction_id === payLoad.transaction_id;
    });
    if (findIndex !== undefined && findIndex > -1) {
      state.failedOffer.splice(findIndex, 1);
    }
  },
  [types.UPDATE_PAYMENT_SWITCH_THRESHOLD](state: any, payLoad: any) {
    state.paymentSwitchThreshold = payLoad;
  },
  [types.UPDATE_LAST_SPECIAL_PURCHASED](state: any, payLoad: any) {
    state.lastPurchasedSpecialOffer = payLoad;
  },
  [types.UPDATE_ORDER_STATUS](state: any, payLoad: any) {
    state.orderStatus = payLoad;
  },
  [types.UPDATE_RECOMMEND_ORDER_STATUS](state: any, payLoad: any) {
    state.isRecommendOrder = payLoad;
  }
};
